module.exports = __webpack_public_path__ + "static/img/mypage_hover.81548c99.svg";